<div class="sopo-popup-inner-container coinflow-inner-container">
  <div class="sopo-popup-title">Purchase Method</div>
  <div class="sopo-popup-text">Select your payment method</div>
  <div class="sopo-puchase-methods">

    <!-- Pay Now option -->
    <div
      class="payment-option-wrapper"
      [class.selected-purchase-method]="selected === 'payNow'"
      (click)="selected = 'payNow'"
    >
      <img class="payment-option-img" src="assets/img/sweep/purchase-default-option-new.webp" alt="Pay">
      <div class="text">Pay Now</div>
    </div>

    <!-- Wallet Balance option -->
    <div
      class="wallet-balance-warapper"
      [class.selected-purchase-method]="selected === 'walletBalance'"
      (click)="selected = 'walletBalance'"
    >
      <img class="wallet-balance-option-img" src="assets/img/sweep/cashier/crypto-background-image.webp">
      <div class="text">Wallet Balance</div>
      <div class="balance">
        <div class="sweepbucks-wrapper">
            <img class="money" src="assets/img/sweep/cashier/crypto-background-image.webp" alt="money">
            <div class="value">
                ${{ sopoWalletBalance }}
            </div>
        </div>
      </div>
    </div>

  </div>
  <div class="price-wrapper">
    <div class="price-text">Price:</div>
    <div class="price-amount">
      {{ getDisplayPrice() }}
    </div>
  </div>
  <div class="sopo-popup-button-container">
    <div class="sopo-popup-green-button" (click)="purchase()">
      {{ buttonText }}
    </div>
  </div>
</div>
